module.exports = __webpack_public_path__ + "static/media/bg_icon_1.e37ecd25.svg";